import Component from '../core/Component'

export default class LightboxOpener extends Component {

    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = event => {
        const slider = Component.getFromElement(this.element.closest('[data-component="SideSlider"]'))

        if (slider?.isDragging) {
            return
        }

        const lightbox = Component.getFromElement('lightbox')

        if (lightbox) {
            event.preventDefault()
            lightbox.show(this.options.id)
        }
    }

}